import React from "react";
import { WorkflowsCardsProps } from "./WorkflowCards.types";
import WorkflowCard from "./WorkflowTemplateCard/WorkflowTemplateCard";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import { useWorkflowTemplateSelection } from "./WorkflowTemplateSelection.hooks";
import { CreateWorkflowDialog } from "../CreateWorkflow/CreateWorkflow";
import useCreateWorkflow from "../CreateWorkflow/CreateWorkflow.hooks";
import { CreateCard } from "./WorkflowTemplateCard/CreateWorkflowCard";
import ComponentLoader from "../ComponentLoader/ComponentLoader";
import { CloseBig } from "@tiny/icons";
import { useDrawerInvokers } from "@tiny/lib";

function WorkflowTemplateSelection() {
  const { templates, isWorkflowTemplatesLoading } =
    useWorkflowTemplateSelection();

  const { hideDrawer } = useDrawerInvokers();

  const createWorkflow = useCreateWorkflow();

  return (
    <Box
      sx={{
        width: "60vw",
        py: 4,
        px: 6,
      }}
    >
      {isWorkflowTemplatesLoading ? (
        <ComponentLoader height="400px" />
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 4,
            }}
          >
            <Typography
              variant="h3"
              fontWeight="semiBold"
              color="grey.100"
              noWrap
            >
              Pick from predefined workflow
            </Typography>
            <IconButton onClick={hideDrawer}>
              <CloseBig />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 6 }} />
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(3, minmax(200px, 1fr))",
            }}
            gap={4}
            justifyContent="center"
          >
            {templates?.map((workflow) => (
              <WorkflowCard
                key={workflow.id}
                name={workflow.name}
                description={workflow.description}
                infoDescription={workflow.infoDescription}
                imagePath={workflow.imagePath}
                status={workflow.status}
                onActionClick={() => {
                  createWorkflow.openWorkflowDialog(workflow.id);
                }}
              />
            ))}
          </Box>
        </>
      )}
      <CreateWorkflowDialog {...createWorkflow} />
    </Box>
  );
}

export default WorkflowTemplateSelection;
